export enum Roles {
    SuperAdmin,
    Admin,
    ContentEditor,
    Client
}